import { gql } from '@apollo/client/core';
import {
  Blend,
  Origin,
  PrimaryVariety,
  ResidualSugar,
  TotalAcidity,
  Vintage,
  WineColor,
} from '.';
import productFragment from '../Product/productFragment';

const wineFragment = gql`
  fragment Wine on RegisteredProduct {
    ...Product
    product {
      ...Blend
      ...Origin
      ...PrimaryVariety
      ...ResidualSugar
      ...TotalAcidity
      ...Vintage
      ...WineColor
    }
  }

  ${productFragment}
  ${Blend.fragment}
  ${Origin.fragment}
  ${PrimaryVariety.fragment}
  ${ResidualSugar.fragment}
  ${TotalAcidity.fragment}
  ${Vintage.fragment}
  ${WineColor.fragment}
`;

export default wineFragment;
